module.exports = __webpack_public_path__ + "img/header.148f2e8a.png";